import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NSGridActionCellModule, NSGridModule } from '@norfolk-southern/accessns-components';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';

import { AdditionalContactsRoutingModule } from '@ruby/modules/short-line-profile/submodules/additional-contacts/additional-contacts-routing.module';
import { AdditionalContactsComponent } from '@ruby/modules/short-line-profile/submodules/additional-contacts/components/additional-contacts.component';
import { AdditionalContactsContainer } from '@ruby/modules/short-line-profile/submodules/additional-contacts/containers/additional-contacts.container';
import { ContactActionsContainer } from '@ruby/modules/short-line-profile/submodules/additional-contacts/containers/contact-actions/contact-actions.container';
import { ShortLineModule } from '@ruby/shared/dialogs/short-line/short-line.module';

@NgModule({
  declarations: [AdditionalContactsComponent, AdditionalContactsContainer, ContactActionsContainer],
  imports: [
    CommonModule,
    MatButtonModule,
    MatDividerModule,
    AdditionalContactsRoutingModule,
    NSGridModule,
    MatIconModule,
    MatTooltipModule,
    ShortLineModule,
    NSGridActionCellModule,
    SweetAlert2Module
  ],
  exports: [AdditionalContactsContainer]
})
export class AdditionalContactsModule {}
